export default __webpack_public_path__ + "static/image-nos-usine-0c891f6574f4d1a144ba0af9534d037e.png";